import { render, staticRenderFns } from "./cropPesticide.vue?vue&type=template&id=61072bca&scoped=true"
import script from "./cropPesticide.vue?vue&type=script&lang=js"
export * from "./cropPesticide.vue?vue&type=script&lang=js"
import style0 from "./cropPesticide.vue?vue&type=style&index=0&id=61072bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61072bca",
  null
  
)

export default component.exports